/*!
 * object-extend
 * A well-tested function to deep extend (or merge) JavaScript objects without further dependencies.
 *
 * http://github.com/bernhardw
 *
 * Copyright 2013, Bernhard Wanger <mail@bernhardwanger.com>
 * Released under the MIT license.
 *
 * Date: 2013-04-10
 */


/**
 * Extend object a with object b.
 *
 * @param {Object} a Source object.
 * @param {Object} b Object to extend with.
 * @returns {Object} a Extended object.
 */
module.exports = function extend(a, b) {

  // Don't touch 'null' or 'undefined' objects.
  if (a == null || b == null) {
      return a;
  }

  // TODO: Refactor to use for-loop for performance reasons.
  Object.keys(b).forEach(function (key) {

      // Detect object without array, date or null.
      // TODO: Performance test:
      // a) b.constructor === Object.prototype.constructor
      // b) Object.prototype.toString.call(b) == '[object Object]'
      if (Object.prototype.toString.call(b[key]) === '[object Object]') {
          if (Object.prototype.toString.call(a[key]) !== '[object Object]') {
              a[key] = b[key];
          } else {
              a[key] = extend(a[key], b[key]);
          }
      } else {
          a[key] = b[key];
      }

  });

  return a;

};


// WEBPACK FOOTER //
// ./src/utils/extend.js